import {db} from '@src/services/db'
import {useObservable} from "@vueuse/rxjs";
import {liveQuery} from "dexie";

export function useLocations() {

    function getLocations() {
        return useObservable<any[]>(
            // @ts-ignore
            liveQuery(async () => {
                const locations = await db.locations.toArray()

                return locations
            }),
            {
                initialValue: []
            }
        )
    }

    return {
        getLocations
    }
}
